<template>
    <div v-if="!toggleDisplay" class="form-search-wrapper">
        <div v-if="title" class="form-search-title">{{ title }}</div>
        <div class="form-search">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        columnForm: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        toggleDisplay() {
            return this.$store.state.toggleDisplay.toggleDisplay
        },
        formHeight() {
            return this.toggleDisplay ? '0px' : `${this.columnForm * 50 + 20}px`
        }
    }
}
</script>

<style scoped>
.form-search-wrapper {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin: 20px;
    background: #ffffff;
    padding: 20px;
}

.form-search-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--black-common);
    margin-bottom: 15px;
    text-align: left;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;
}

.form-search {
    line-height: 32px;
}

.label {
    margin-right: 10px;
    font-weight: 600;
    min-width: 100px;
}

.label-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    padding-right: 10px;
}
.control-label {
    font-size: 13px;
    text-align: right;
    word-wrap: break-word;
    line-height: 1.4;
}

@media only screen and (max-width: 767px) {
    .form-search-wrapper {
        margin: 10px;
        padding: 15px;
    }

    .form-search {
        line-height: 0px;
        height: 100% !important;
    }
    .row {
        flex-direction: column;
    }

    .label-wrapper {
        position: static;
        text-align: left;
        margin-bottom: 5px;
    }
    .mobi {
        margin-top: 20px;
    }
}
</style>
